import { Image } from '../../../../../common/image'
import TVSvg from '../../../corporatePerformanceScore/common/icon/imgTivi.png'

export const Tivi = () => {
  return (
    <Image
      src={TVSvg}
      style={{ height: 450, width: 450 }}
      alt="monitor standard"
    />
  )
}
